import React from 'react' ; 
import Introduction from './components/Introduction/Introduction';
import ProfessionalExperience from './components/ProfessionalExperience/ProfessionalExperience';
import Skill from './components/Skills/Skills';
import Projects from './components/Projects/Projects';
import ContactMe from './components/ContactMe/ContactMe';

function App() {
  return (
    <div className="App">
      <Introduction />
      <Skill />
      <ProfessionalExperience />
      <Projects />
      <ContactMe />
    </div>
  );
}

export default App;
